import { Box, SxProps, Typography } from "@mui/material";
import { colors } from "../../theme/colors";

type Props = {
  children?: React.ReactNode;
  sx?: SxProps;
  padding?: boolean;
  logoBackground?: boolean;
  title?: string;
  subTitle?: string;
};

export const ContentWrapper = ({
  children,
  sx = {},
  padding = true,
  logoBackground = true,
  title,
  subTitle
}: Props) => {
  return (
    <Box
      sx={{
        flex: "1 0 auto",
        flexDirection: "column",
        display: "flex",
        pt: padding ? 15 : 0,
        px: padding ? { xs: 4, md: 6 } : 0,
        position: "relative",
        ...sx
      }}>
      {logoBackground && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: "url(/images/logo_background.png)",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPositionX: "-10rem",
            backgroundPositionY: "-10rem",
            zIndex: -1
          }}
        />
      )}
      {title && (
        <Typography
          variant="h1"
          textAlign="center"
          mt={{ xs: 4, md: 8 }}
          mb={subTitle ? { xs: 1, md: 2 } : { xs: 4, md: 8 }}>
          {title}
        </Typography>
      )}
      {subTitle && (
        <Typography variant="h5" textAlign="center" color={colors.grey2} mb={{ xs: 4, md: 8 }}>
          {subTitle}
        </Typography>
      )}

      {children}
    </Box>
  );
};
